import {
  navyDefenceData,
  industriesMeta,
  maritimeData,
  mobileData,
  aeronauticsData,
} from 'constants/industries/industries';
import { DropdownItem } from './Dropdown';

import {
  aboutMeta,
  careersMeta,
  intelligentSystemTestingApplicationMeta,
  airbusHelicopterCustomerCaseMeta,
  reinforcementLearningApplicationMeta,
  intelligentDataPipelineApplicationMeta,
  automaticDatasetEnhancementApplicationMeta,
  hondaMarineCustomerCaseMeta,
  brunswickUseCaseCustomerCaseMeta,
  airbusUpNextCustomerCaseMeta,
  applicationsMeta,
  customerCaseMeta,
  portOperationsCustomerCaseMeta,
  platformMeta,
  sensorsMeta,
  intelligentSystemTestingMeta,
  counterDroneMeta,
  airportGroundOpsMeta,
  interceptorUsvMeta,
  actionPacksMeta,
} from 'constants/pages';
import { isDemo, isDev } from 'constants/env';

export const companyItems: DropdownItem[] = [
  { name: 'About us', to: aboutMeta.url },
  { name: 'Careers', to: careersMeta.url },
];

export const platformItems: DropdownItem[] = [
  { name: 'Overview', to: platformMeta.url },
  { name: 'Sensors', to: sensorsMeta.url },
];

export const industriesItems: DropdownItem[] = [
  { name: 'All Industries', to: industriesMeta.url },
  { name: 'Maritime', to: maritimeData.meta.url },
  { name: 'Navy & Defense Sector', to: navyDefenceData.meta.url },
  { name: 'Aeronautics', to: aeronauticsData.meta.url },
  { name: 'Mobile Machines', to: mobileData.meta.url },
];

export const applicationsItems: DropdownItem[] = [
  { name: 'All Applications', to: applicationsMeta.url },
  {
    name: 'Intelligent System Testing',
    to: intelligentSystemTestingApplicationMeta.url,
  },
  {
    name: 'Intelligent Data Pipeline',
    to: intelligentDataPipelineApplicationMeta.url,
  },
  {
    name: 'Automatic Dataset Enhancement',
    to: automaticDatasetEnhancementApplicationMeta.url,
  },
  {
    name: 'Reinforcement Learning',
    to: reinforcementLearningApplicationMeta.url,
  },
];

export const actionPacksItems: DropdownItem[] = [
  { name: 'All Starter Packs', to: actionPacksMeta.url },
  { name: 'Intelligent System Testing', to: intelligentSystemTestingMeta.url },
  { name: 'Counter-Drone', to: counterDroneMeta.url },
  { name: 'Airport Ground Ops', to: airportGroundOpsMeta.url },
  { name: 'Interceptor USV', to: interceptorUsvMeta.url },
];

export const customerCasesItems: DropdownItem[] = [
  { name: 'All Customer Cases', to: customerCaseMeta.url },
  { name: 'Anti-Collision Systems', to: airbusHelicopterCustomerCaseMeta.url },
  { name: 'AI-Powered Auto-Docking', to: brunswickUseCaseCustomerCaseMeta.url },
  { name: 'Autonomous Aircraft Taxiing', to: airbusUpNextCustomerCaseMeta.url },
  { name: 'Port Operations', to: portOperationsCustomerCaseMeta.url},
  // Show Honda Marine case only in demo/dev environments
  ...(isDemo || isDev ? [{ name: 'Honda Marine', to: hondaMarineCustomerCaseMeta.url }] : []),
];
